import { auth, googleProvider } from "../authMethods/firebaseConfig"; // Adjust the path to your Firebase setup file
import { signInWithPopup,signInWithRedirect  } from "firebase/auth";


export const signInWithGoogle = async () => {
    try {
        
        await signInWithRedirect(auth, googleProvider);
        // const result = await signInWithRedirect(auth, googleProvider);
        // const user = result.user;
        // console.log("Google sign-in successful:", user);
        // return user; // Return the signed-in user
      } catch (error) {
        console.error("Error during Google sign-in:", error);
        throw error;
      }
};

/*
try {
    const result = await signInWithPopup(auth, googleProvider);
    const user = result.user;
    console.log("Google sign-in successful!", user);
  } catch (error) {
    console.error("Error during Google sign-in:", error);
  }
*/